import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import config from "../../config/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const MaintenancescheduleModal = ({ show, handleClose,onNewMaintenance }) => {
  const [machines, setMachines] = useState([]);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    machine: "",
    date_of_maintenance: "",
    days_required: "",
    maintenance_type: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({
      ...prev,
      message: { ...prev.message, [name]: "" },
    }));
  };
  const handleMachineChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      machine: selectedOption?.value || "",
    }));
    setErrors((prev) => ({
      ...prev,
      message: { ...prev.message, machine: "" },
    }));
  };
  const fetchMachineList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/machine/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMachines(response.data.machines || []);
    } catch (err) {
      console.error("Error fetching machines:", err.message);
    }
  };
  useEffect(() => {
    fetchMachineList();
  }, []);

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) return console.error("No auth token found");

    try {
      const res = await axios.post(
        `${config.API}/manager/createmaintenanceschedule`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(res.data.message || "Maintenance record saved successfully");
      onNewMaintenance()
      handleClose();
    } catch (err) {
      console.error("Error submitting data:", err.response?.data || err.message);
      if (err.response?.status === 422) {
        setErrors(err.response.data);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    }
  };
  const machineOptions = machines.map((machine) => ({
    value: machine.id,
    label: `${machine.name} (${machine.machine_code})`
  }));
  const selectedMachine =
    machineOptions.find((option) => option.value === formData.machine) || null;
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="p-5 font_family">
        <strong className="fs-4">Preventive Maintenance Window</strong>
        <Form>
          <Form.Group className="mb-3 mt-4">
            <Row className="align-items-center">
              <Col xs={4} md={3}>
                <strong>Machine</strong>
              </Col>
              <Col xs={8} md={9}>
                <Select
                  name="machine"
                  value={selectedMachine}
                  onChange={handleMachineChange}
                  options={machineOptions}
                  placeholder="Select Machine"
                  className={errors.message?.machine ? "is-invalid" : ""}
                />
                {errors.message?.machine && (
                  <div className="text-danger small">
                    {errors.message.machine[0]}
                  </div>
                )}
              </Col>
            </Row>
          </Form.Group>
          <Row className="mb-3 align-items-center">
            <Col md={6}>
              <Row className="align-items-center">
                <Col xs={5}>
                  <strong>Date of Maintenance</strong>
                </Col>
                <Col xs={7}>
                  <Form.Control
                    type="date"
                    name="date_of_maintenance"
                    value={formData.date_of_maintenance}
                    onChange={handleChange}
                    className={`rounded ${
                      errors.message?.date_of_maintenance ? "is-invalid" : ""
                    }`}
                  />
                  {errors.message?.date_of_maintenance && (
                    <div className="text-danger small">
                      {errors.message.date_of_maintenance[0]}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>

            <Col md={6}>
              <Row className="align-items-center">
                <Col xs={5}>
                  <strong>Days Required</strong>
                </Col>
                <Col xs={7}>
                  <Form.Control
                    type="number"
                    name="days_required"
                    value={formData.days_required}
                    onChange={handleChange}
                    className={`rounded ${
                      errors.message?.days_required ? "is-invalid" : ""
                    }`}
                  />
                  {errors.message?.days_required && (
                    <div className="text-danger small">
                      {errors.message.days_required[0]}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Maintenance Type */}
          <Form.Group className="mb-3">
            <Row className="align-items-start">
              <Col xs={4} md={3}>
                <strong>Maintenance Type</strong>
              </Col>
              <Col xs={8} md={9}>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="maintenance_type"
                  value={formData.maintenance_type}
                  onChange={handleChange}
                  className={`rounded ${
                    errors.message?.maintenance_type ? "is-invalid" : ""
                  }`}
                  placeholder="Enter maintenance type..."
                />
                {errors.message?.maintenance_type && (
                  <div className="text-danger small">
                    {errors.message.maintenance_type[0]}
                  </div>
                )}
              </Col>
            </Row>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaintenancescheduleModal;
